import React from 'react';
import Loading from 'src/components/Loading/Loading';
import { observer } from 'src/utils/mobx-react';
import { WithdrawalRequestsRow } from './WithdrawalRequestsRow';
import {
    TableWrapper,
    SectionHeader,
    ColumnHeader,
    TableHeaderRow,
    SectionMessage,
    SectionWrapper,
    SmallLoader,
} from './WithdrawalRequests.style';
import { ViewType, WithdrawalState } from 'src/AppState/WithdrawalState';
import { useAppStateContext } from 'src/AppState/AppState';
import { ModelsState } from 'src/AppState/Models/ModelsState';

const renderList = (type: ViewType, list: Array<number>, models: ModelsState): Array<React.ReactNode> => {
    const elements: Array<React.ReactNode> = [];

    for (const withdrawalId of list) {
        elements.push(
            <WithdrawalRequestsRow
                key={withdrawalId}
                withdrawalId={withdrawalId}
                type={type}
                dataTest={`withdrawal-row-${withdrawalId}`}
                models={models}
            />
        );
    }

    return elements;
};

interface PropsType {
    type: ViewType;
    header: string;
    withdrawalState: WithdrawalState;
}

export const WithdrawalRequests = observer('WithdrawalRequests', (props: PropsType): React.ReactElement => {
    const { models } = useAppStateContext();
    const { header, type } = props;

    const withdrawalList = props.withdrawalState.allList;
    const withdrawListByType = props.withdrawalState.getListByType(type);

    if (withdrawalList === null) {
        return (
            <div>
                <SectionHeader>{header}</SectionHeader>
                <Loading
                    message='Loading...'
                    active={true}
                />
            </div>
        );
    }

    if (withdrawListByType.length === 0) {
        const message = <SectionMessage>There are no items</SectionMessage>;
        return (
            <div>
                <SectionHeader>{header}</SectionHeader>
                {message}
            </div>
        );
    }

    return (
        <div>
            <SectionHeader>{header}</SectionHeader>
            <SectionWrapper>
                <SmallLoader isActive={type === 'your' && props.withdrawalState.isAnyCompleting} />
                <TableWrapper data-test={`withdrawal-requests-section-${header.toLowerCase().replaceAll(' ', '-')}`}>
                    <thead>
                        <TableHeaderRow>
                            <ColumnHeader>Date</ColumnHeader>
                            <ColumnHeader>Customer Details</ColumnHeader>
                            <ColumnHeader>Amount (£)</ColumnHeader>
                            <ColumnHeader>Payment Details</ColumnHeader>
                            <ColumnHeader>Bank Account Holder</ColumnHeader>
                            <ColumnHeader>Actions</ColumnHeader>
                        </TableHeaderRow>
                    </thead>
                    <tbody>{renderList(type, withdrawalList, models)}</tbody>
                </TableWrapper>
            </SectionWrapper>
        </div>
    );
});
